export default "__VITE_ASSET__BdQzQVpE__"